export default {
  buttons: {
    cancel: "Zrušit",
    dismiss: "Zavřít",
    add_waypoint: "Přidejte cíl"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Vyhledat ",
    placeholder: "Zadejte polohu",
    enter_location: "Zadejte polohu",
    help: {
      inactive: "Vyhledat "
    }
  },
  filters: {
    title: "Filtry",
    amenities: {
      title: "Služby a vybavení"
    },
    fuels: {
      title: "Druhy paliv"
    }
  },
  directions: {
    title: "Plánovač trasy",
    placeholder: {
      destination: "Zadejte polohu",
      waypoint: "Zadejte polohu"
    },
    route: {
      title: "Možnosti trasy",
      avoid_tolls: "Vypustit placené úseky",
      avoid_highways: "Vypustit dálnice",
      title_corridor: "Vzdálenost k čerpací stanici"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# wk} other {# wks}}
{days, plural, =0 {} =1 {# den} other {# dny}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# min}}\
`,
    button: "Vyhledat "
  },
  locations: {
    title: "oblasti",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} od {place}"
  },
  open_now: {
    open_24_hours: "Otevřeno 24 hodin"
  },
  info_window: {
    title: "Detaily stanice",
    services: "Služby a vybavení",
    nearby: "V blízkosti",
    opening_hours: {
      title: "Otevírací hodiny",
      mon: "Po",
      tue: "Út",
      wed: "St",
      thu: "Čt",
      fri: "Pá",
      sat: "So",
      sun: "Ne",
      open_twentyfourhours: "Otevřeno 24 hodin",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      price: "{price, number, fuelPrice}",
      last_updated_on: "Poslední aktualizace",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Plánovač trasy"
  },
  fuels: {
    autogas_lpg: "Autogas (LPG)",
    fuelsave_midgrade_gasoline: "Shell FuelSave Natural 95",
    fuelsave_regular_diesel: "Shell FuelSave Diesel",
    premium_diesel: "Shell V-Power Diesel",
    premium_gasoline: "Shell V-Power 95",
    super_premium_gasoline: "Shell V-Power Racing"
  },
  amenities: {
    air_and_water: "Vzduch",
    atm: "Bankomat",
    austrian_highway_sticker: "Dálniční známka - Rakousko",
    bottled_gas: "Výměna PB lahví",
    cafe: "Kavárna",
    carwash: "Myčka",
    clubsmart_card: "Karta Club Smart",
    credit_card_american_express: "Kreditní karta AMEX",
    credit_card_diners_club: "Kreditní karta Diners Club",
    credit_card_mastercard: "Kreditní karta Mastercard",
    credit_card_visa: "Kreditní karta VISA",
    credit_card: "Kreditní karta",
    czech_highway_sticker: "Dálniční známka - Česká republika",
    euroshell_card: "EuroShell Card ",
    fleet_card_dkv: "Palivová karta - DKV",
    fleet_card_eni: "Palivová karta - ENI",
    fleet_card_esso: "Palivová karta - ESSO",
    fleet_card_general: "Palivová karta",
    fleet_card_uta: "Palivová karta - UTA",
    food_offerings: "Nabídka stravy",
    full_service: "Všechny služby/ Využité služby",
    guarded_car_park: "Hlídané parkoviště",
    hgv_lane: "Vhodná i pro nákladní vozidla",
    high_speed_diesel_pump: "Rychlovýdej",
    hot_food: "Teplé jídlo",
    hungarian_highway_sticker: "Dálniční známka - Maďarsko",
    maut_terminal: "Mýtný terminál",
    mobile_payment: "Mobilní placení",
    parking_lanes: "Parkoviště",
    partner_loyalty_accepted: "Akceptován věrnostní program",
    pay_at_pump: "Platba na stojanu",
    quick_lubes: "Rychloservis",
    restaurant: "Restaurace",
    self_service: "Samoobsluha",
    service_bay: "Servis",
    shell_card: "EuroShell Card ",
    shop: "Prodejna",
    shower: "Sprcha",
    slovak_highway_sticker: "Dálniční známka - Slovensko",
    snack_food: "Snack/ Rychlé občerstvení",
    standard_toilet: "Toalety",
    supermarket_fuel_discount: "Sleva na palivo",
    toilet: "Toalety",
    truck_parking: "Parkování pro nákladní vozidla",
    truckport: "Pouze pro nákladní vozidla",
    twenty_four_hour: "24 hodin",
    vacuum: "Vysavač"
  },
  settings: {
    title: "Nastavení",
    tooltip: "Nastavení",
    distance_units: {
      title: "Vzdálenost",
      km: "km",
      miles: "mi"
    },
    language: {
      title: "Jazyk"
    }
  }
}
